import React from 'react'
import NavbarAccount from '../components/NavbarAccount';

function Account() {
  return (
    <div>
      <div className="head-title">
        My account
      </div >
      <NavbarAccount/>
    </div>
  )
}

export default Account